<template>
  <div class="data-quality-wrapper">
    <div class="elevation-1 chartWrapper data-quality-card">
      <div class="chart-title d-block text-center">{{ providerName }} VFM score compared to the market</div>
      <div class="text-right mr-10 mb-6">
        <v-btn elevation="2" @click="expand">Expand graph</v-btn>
      </div>

      <div class="d-flex">
        <base-chart :options="chartOptions" :scroll-options="chartSize" />
      </div>
      <div>
        <v-list class="d-flex" style="margin-left: 5rem">
          <v-row>
            <v-col>
              <v-list-item color="#ccc" class="align-center">
                <template v-slot:prepend>
                  <v-icon class="mr-0" color="#e62e00" style="font-size: 12px !important">fas fa-circle</v-icon>
                </template>
                <v-list-item-title style="font-size: 13px !important">My Scheme</v-list-item-title>
              </v-list-item>
            </v-col>
            <v-col>
              <v-list-item color="#ccc" class="align-center">
                <template v-slot:prepend>
                  <v-icon class="mr-0" color="#008000" style="font-size: 12px !important">fas fa-circle</v-icon>
                </template>
                <v-list-item-title style="font-size: 13px !important"
                  >Schemes accepting full <br />
                  consolidation</v-list-item-title
                >
              </v-list-item>
            </v-col>
            <v-col>
              <v-list-item color="#ccc" class="align-center">
                <template v-slot:prepend>
                  <v-icon class="mr-0" color="#0066cc" style="font-size: 12px !important">fas fa-circle</v-icon>
                </template>
                <v-list-item-title style="font-size: 13px !important">Other Scheme types</v-list-item-title>
              </v-list-item></v-col
            >
          </v-row>
        </v-list>
        <v-list class="d-flex" style="margin-left: 5rem">
          <v-row>
            <v-col>
              <v-list-item color="#ccc" class="align-center">
                <template v-slot:prepend>
                  <v-img class="mr-6" width="14px" src="../../assets/circle-icon-green.png" />
                </template>
                <v-list-item-title style="font-size: 13px !important"
                  >Schemes accepting full <br />
                  consolidation (limited)</v-list-item-title
                >
              </v-list-item>
            </v-col>
            <v-col>
              <v-list-item color="#ccc" class="align-center">
                <template v-slot:prepend>
                  <v-img class="mr-6" width="14px" src="../../assets/circle-icon-blue.png" />
                </template>
                <v-list-item-title style="font-size: 13px !important"
                  >Other Scheme types<br />
                  (limited)</v-list-item-title
                >
              </v-list-item></v-col
            >
            <v-col><v-list-item> </v-list-item> </v-col>
          </v-row>
        </v-list>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue, Prop } from 'vue-property-decorator';
import BaseChart from '@/components/charts/BaseChart.vue';
import Utils from '../../utils/Utils';

const mapConsolidator = {
  yes: 'Accepting Full Consolidation',
  no: 'Not Accepting Consolidation',
  partial: 'Accepting Partial Consolidation',
};

const fullConPrviderList = [
  'Aviva',
  'Standard Life',
  'L&G',
  'Aegon',
  'Fidelity',
  'Lifesight',
  'Nest',
  "People's Pension",
  'Mercer',
  'Now Pensions',
];

const otherConPrviderList = ['Hargreaves Lansdown', 'Prudential'];

export default {
  components: {
    BaseChart,
  },
  props: ['data', 'providerName', 'providerId', 'providerDataQuality', 'expandGraph'],
  data() {
    return {
      chartData: [],
      chartSize: {
        chartWidth: 75,
        chartHeight: 30,
        unit: 'rem',
      },
      chartOptions: {},
    };
  },
  mounted() {
    this.setChartData();
    this.setOption();
  },
  watch: {
    data(newVal, oldVal) {
      this.chartData = [];
      this.chartOptions = {};
      this.setChartData();
      this.setOption();
    },
  },
  methods: {
    setChartData() {
      if (this.data) {
        const isProviderAvailable = this.data.find((it) => it.providerId === this.providerId);
        this.data.forEach((element) => {
          let colorCode = '#0066cc';
          if (element.consolidator == 'yes') {
            colorCode = '#008000';
          }
          if (element.providerId == this.providerId) {
            colorCode = '#e62e00';
          }
          if (fullConPrviderList.includes(element.name)) {
            this.chartData.push({
              value: [
                element.total_nav,
                element.avg_score,
                element.tax_year,
                element.scheme,
                element.consolidator,
                element.pathway,
                element.data_type,
              ],
              symbolSize: 17,
              itemStyle: {
                color: colorCode,
              },
              symbol: `image://data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idX
              RmLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly
              93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNIDUwMyAyNTYgQyA1MDMgMzI0LjI5
              NiA0NzUuNDE3IDM4NS45MTkgNDMwLjY2OCA0MzAuNjY4IEMgMzg1LjkxOSA0NzUu
              NDE3IDMyNC4yOTYgNTAzIDI1NiA1MDMgQyAxODcuNzA0IDUwMyAxMjYuMDgxIDQ3NS40MTcgODEuMzMy
              IDQzMC42NjggQyAzNi41ODMgMzg1LjkxOSA5IDMyNC4yOTYgOSAyNTYgQy
              A5IDE4Ny43MDQgMzYuNTgzIDEyNi4wODEgODEuMzMyIDgxLjMzMiBDIDEyNi4wODEgMzYuNTgzIDE4Ny
              43MDQgOSAyNTYgOSBDIDMyNC4yOTYgOSAzODUuOTE5IDM2LjU4MyA0MzAuNj
              Y4IDgxLjMzMiBDIDQ3NS40MTcgMTI2LjA4MSA1MDMgMTg3LjcwNCA1MDMgMjU2IFoiIHN0eWxlPSJmaWxsOiBy
              Z2IoMCwgMTI4LCAwKTsgZmlsbC1ydWxlOiBub256ZXJvOyBwYWludC1
              vcmRlcjogZmlsbDsiLz4KICA8cmVjdCBzdHlsZT0iZmlsbDogcmdiKDIzMCwgNDYsIDApOyBmaWxsLXJ1bGU6IG
              5vbnplcm87IHBhaW50LW9yZGVyOiBzdHJva2U7IHN0cm9rZTog
              cmdiKDIzMCwgNDYsIDApOyIgdHJhbnNmb3JtPSJtYXRyaXgoLTAuNzA3MDksIDAuNzA3MTI0LCAtMC43MDM1Mjg
              sIC0wLjcxMDY4NSwgNzE4OC4wOTYxOTEsIDY3MDUuNzU1MzcxKSIge
              D0iMTM5LjM3OCIgeT0iOTQyNC41MzkiIHdpZHRoPSI0OTQuMzI4IiBoZWlnaHQ9IjYxLjE2MSIvPgo8L3N2Zz4=`,
            });
          } else if (otherConPrviderList.includes(element.name)) {
            this.chartData.push({
              value: [
                element.total_nav,
                element.avg_score,
                element.tax_year,
                element.scheme,
                element.consolidator,
                element.pathway,
                element.data_type,
              ],
              symbolSize: 17,
              itemStyle: {
                color: colorCode,
              },
              symbol: `image://data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aW
              V3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNIDUwMyAy
              NTYgQyA1MDMgMzI0LjI5NiA0NzUuNDE3IDM4NS45MTkgNDMwLjY2OCA0MzAuNjY4IEMgMzg1LjkxOSA0NzUuNDE3I
              DMyNC4yOTYgNTAzIDI1NiA1MDMgQyAxODcuNzA0IDUwMyAxMjYuMDgxIDQ3NS40MTcgODEuMzMyIDQzMC42NjggQyA
              zNi41ODMgMzg1LjkxOSA5IDMyNC4yOTYgOSAyNTYgQyA5IDE4Ny43MDQgMzYuNTgzIDEyNi4wODEgODEuMzMyID
              gxLjMzMiBDIDEyNi4wODEgMzYuNTgzIDE4Ny43MDQgOSAyNTYgOSBDIDMyNC4yOTYgOSAzODUuOTE5IDM2LjU4My
              A0MzAuNjY4IDgxLjMzMiBDIDQ3NS40MTcgMTI2LjA4MSA1MDMgMTg3LjcwNCA1MDMgMjU2IFoiIHN0eWxlPSJm
              aWxsLXJ1bGU6IG5vbnplcm87IHBhaW50LW9yZGVyOiBmaWxsOyBmaWxsOiByZ2IoMCwgMTAyLCAyMDQpOyIvPgo
              gIDxyZWN0IHN0eWxlPSJmaWxsOiByZ2IoMjMwLCA0NiwgMCk7IGZpbGwtcnVsZTogbm9uemVybzsgcGFpbnQtb3J
              kZXI6IHN0cm9rZTsgc3Ryb2tlOiByZ2IoMjMwLCA0NiwgMCk7IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC43MDcwOSwg
              MC43MDcxMjQsIC0wLjcwMzUyOCwgLTAuNzEwNjg1LCA3MTg4LjA5NjE5MSwgNjcwNS43NTUzNzEpIiB4PSIxMzkuM
              zc4IiB5PSI5NDI0LjUzOSIgd2lkdGg9IjQ5NC4zMjgiIGhlaWdodD0iNjEuMTYxIi8+Cjwvc3ZnPg==`,
            });
          } else {
            this.chartData.push({
              value: [
                element.total_nav,
                element.avg_score,
                element.tax_year,
                element.scheme,
                element.consolidator,
                element.pathway,
                element.data_type,
              ],
              itemStyle: {
                color: colorCode,
              },
              symbolSize: 17,
            });
          }
        });
        if (!isProviderAvailable) {
          this.chartData.push({
            value: [this.providerDataQuality.asset_size, +this.providerDataQuality.score],
            itemStyle: {
              color: '#e62e00',
            },
            symbolSize: 17,
          });
        }
      }
    },
    setOption() {
      this.chartOptions = {
        tooltip: {
          show: true,
          formatter: (v) => {
            return (
              v.value &&
              `Asset Size: ${Utils.formatNumber(v.value[0], '$0a')} <br /> Score: ${v.value[1].toFixed(0)} ${
                (v.value[2] && `<br /> Tax Year: ${v.value[2]}`) || ''
              } ${(v.value[3] && `<br /> Scheme: ${v.value[3]}`) || ''}  ${
                (v.value[4] && `<br /> Consolidator: ${mapConsolidator[v.value[4]]}`) || ''
              } ${(v.value[5] && `<br /> Pathway: ${v.value[5]}`) || ''} ${
                (v.value[6] && `<br /> Data Type: ${v.value[6]}`) || ''
              }`
            );
          },
        },
        xAxis: {
          name: 'Asset Size (£mn)',
          nameLocation: 'middle',
          nameTextStyle: { fontFamily: 'Open Sans', color: '#6f6c76', padding: 20, fontWeight: 'bold' },
          axisLabel: {
            formatter: (v) => `${(v / 1000000).toFixed(0)}`,
            padding: [0, 0, 0, 0],
            fontWeight: '600',
            fontFamily: 'Open Sans',
            color: '#6f6c76',
            interval: false,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: { show: true, lineStyle: { color: '#6f6c76' } },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          splitNumber: 9,
        },
        yAxis: {
          name: 'AgeWage Score',
          nameLocation: 'middle',
          nameRotate: 90,
          nameTextStyle: { fontFamily: 'Open Sans', color: '#6f6c76', padding: 30, fontWeight: 'bold' },
          axisLabel: {
            fontWeight: '600',
            fontFamily: 'Open Sans',
            color: '#6f6c76',
            interval: false,
          },
          axisLine: { show: true, lineStyle: { color: '#6f6c76' } },
          axisTick: {
            alignWithLabel: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          scale: true,
          max: 100,
          interval: 10,
        },
        series: [
          {
            symbolSize: 13,
            data: this.chartData,
            type: 'scatter',
            markLine: {
              animation: false,
              lineStyle: {
                type: 'solid',
              },
              data: [
                [
                  {
                    coord: [100000000, 0],
                    symbol: 'none',
                    lineStyle: {
                      color: 'red',
                    },
                  },
                  {
                    coord: [100000000, 100],
                    symbol: 'none',
                  },
                ],
                [
                  {
                    coord: [0, 50],
                    symbol: 'none',
                    lineStyle: {
                      color: 'green',
                    },
                  },
                  {
                    coord: [20000000000, 50],
                    symbol: 'none',
                  },
                ],
              ],
            },
          },
        ],
      };
    },
    expand() {
      this.$emit('expandGraph');
    },
  },
};
</script>
<style lang="scss">
.data-quality-wrapper {
  padding: 1rem 0rem !important;
  .data-quality-card {
    padding-bottom: 3rem !important;
  }
}
</style>
